import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useMutation, useQueryClient } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

export enum PreferredWorkerProposalAction {
  ACCEPT = 'accept',
  REJECT = 'reject',
}
export const useActionOnPreferredWorkerProposal = () => {
  const { site } = useSiteDetection();
  const mutationFn = async ({
    proposalId,
    action,
  }: {
    proposalId: string;
    action: PreferredWorkerProposalAction;
  }) => {
    switch (action) {
      case PreferredWorkerProposalAction.ACCEPT:
        await sharedShiftService.acceptPreferredWorkerProposal(site, proposalId);
        break;
      case PreferredWorkerProposalAction.REJECT:
        await sharedShiftService.rejectPreferredWorkerProposal(site, proposalId);
    }
  };
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shifts());
    },
  });
};
